import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { useRef as u, useEffect as o } from "react";
import { attributes as i } from "../utils/attributes.js";
import { classnames as s } from "../utils/classnames.js";
import { c as l } from "../../createLucideIcon-BC8wu-bu.js";
/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f = l("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
function j({
  step: p,
  isActive: a,
  isLast: n,
  isDone: t,
  title: d,
  onClick: r
}) {
  const m = u(!1);
  return o(() => {
    m.current = !0;
  }, []), /* @__PURE__ */ c(
    "div",
    {
      className: s(
        ["stepper-step", !0],
        ["stepper-step-active", a]
      ),
      onClick: () => r == null ? void 0 : r(p),
      ...i({ disabled: !r }),
      children: [
        /* @__PURE__ */ e("div", { className: "stepper-step-info", children: /* @__PURE__ */ e(
          "div",
          {
            className: s(
              ["stepper-number", !0],
              ["stepper-number-active", a],
              ["stepper-number-done", t]
            ),
            children: /* @__PURE__ */ e("span", { className: "stepper-numberValue", children: t ? /* @__PURE__ */ e(f, { size: "1.25rem" }) : p + 1 })
          }
        ) }),
        !n && /* @__PURE__ */ c("div", { className: "stepper-step-between", children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: s(
                ["stepper-separator", !0],
                ["stepper-separator-done", t],
                ["stepper-separator-mounted", m.current]
              )
            }
          ),
          /* @__PURE__ */ e("span", { className: "stepper-text", children: d })
        ] })
      ]
    }
  );
}
export {
  j as Step
};
//# sourceMappingURL=Step.js.map
